import { defineStore } from 'pinia';

export const useRegistrationCodesStore = defineStore('registrationCodes', {
    state: () => ({ 
        video: null,
        showModal: false,
        bodyComponent: null,
        modalOptions: null,
        title: "",
        selectedCode: null,
        // sendInviteId: null,
        refreshCodes: false,
    }),
    getters: {
        // currentVideo: (state) => state.video,
        // // currentComponent: (state) => state.bodyComponent,
        // // currentOptions: (state) => state.modalOptions,
        // // currentTitle: (state) => state.title,
    },
    actions: {
        // refreshCodes() {
        //     console.log('refreshCodes')
        // }
    },
})